import { LOWER_CASED_BRAND_NAME } from './contants';

const getBrandLogo = () => {
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const logo = require(`../../assets/images/logo/${LOWER_CASED_BRAND_NAME}-logo.png`);

    return logo;
  } catch (error) {
    console.log(
      `Failed to load logo image for ${LOWER_CASED_BRAND_NAME} wl`,
      error,
    );
  }
};

export default getBrandLogo;



// WEBPACK FOOTER //
// ./src/whitelabel/helpers/getBrandLogo.js